import {
  PropsWithChildren,
  ReactNode,
  createContext,
  useEffect,
  useState,
} from "react";
import { Owner, OwnerReadResponse } from "src/business/account/owner";
import { API_URL } from "../API";

const defualtUserContext = {
  user: null,
  setUser: (value: Owner) => null,
  isLoading: true,
  refetch: () => {},
};

interface UserContextType {
  user: Owner | null;
  setUser: (value: Owner) => void;
  isLoading: boolean;
  refetch: () => void;
}

export const UserContext = createContext<UserContextType>(defualtUserContext);

const UserProvider = ({ children }: PropsWithChildren<ReactNode>) => {
  const [user, setUser] = useState<Owner | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const initializeUser = async () => {
    setIsLoading(true);

    await fetch(`${API_URL}/staff/me`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((response: OwnerReadResponse) => {
        if (response.success) {
          setUser(response.owner);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    initializeUser();
  }, []);

  const value = { user, setUser, isLoading, refetch: initializeUser };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export default UserProvider;
